import { CardHeader } from "@mui/material";
import type { CardHeaderProps } from "@mui/material/CardHeader";
import type { SxProps, Theme } from "@mui/material/styles";
import "./CustomCardHeader.css";

export interface CustomCardHeaderProps extends Omit<CardHeaderProps, "sx"> {
  titleColor?: string;
  titleFontSize?: string | number;
  subheaderColor?: string;
  subheaderFontSize?: string | number;
  sx?: SxProps<Theme>;
}

export const CustomCardHeader = ({
  titleColor,
  titleFontSize,
  subheaderColor,
  subheaderFontSize,
  sx,
  className,
  titleTypographyProps,
  subheaderTypographyProps,
  ...props
}: CustomCardHeaderProps) => {
  const titleStyle: React.CSSProperties = {
    ...(titleColor ? { color: titleColor } : {}),
    ...(titleFontSize ? { fontSize: titleFontSize } : {}),
    ...titleTypographyProps?.style,
  };

  const subheaderStyle: React.CSSProperties = {
    ...(subheaderColor ? { color: subheaderColor } : {}),
    ...(subheaderFontSize ? { fontSize: subheaderFontSize } : {}),
    ...subheaderTypographyProps?.style,
  };

  const titleClassName = titleTypographyProps?.className
    ? `custom-card-header-title ${titleTypographyProps.className}`
    : "custom-card-header-title";
  const subheaderClassName = subheaderTypographyProps?.className
    ? `custom-card-header-subheader ${subheaderTypographyProps.className}`
    : "custom-card-header-subheader";
  const headerClassName = className
    ? `custom-card-header ${className}`
    : "custom-card-header";

  return (
    <CardHeader
      {...props}
      className={headerClassName}
      titleTypographyProps={{
        ...titleTypographyProps,
        className: titleClassName,
        style: titleStyle,
      }}
      subheaderTypographyProps={{
        ...subheaderTypographyProps,
        className: subheaderClassName,
        style: subheaderStyle,
      }}
      sx={sx}
    />
  );
};